import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Display from "../display/display";
import Money from "../money/money";
const Manageworks = ({userData}) => {
  const [key, setKey] = useState("money");
  const [Datee, setDatee] = useState("");
  const [ManageWorkID, setManageWorkID] = useState("");
  const [Requirework, setRequirework] = useState("");
  const [GehaWork, setGehaWork] = useState("");
  const [MenueWork, setMenueWork] = useState("");
  const [Result, setResult] = useState("");
  const [Notes, setNotes] = useState("");
  const [SelectedFile, setSelectedFile] = useState("");
  const [Description, setDescription] = useState("");
  const [Loading, setLoading] = useState(true);
  const [IsPress, setIsPress] = useState(false);
  const [IsEdit, setIsEdit] = useState(false);
  const [Eye, setEye] = useState(false);

  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة العمل الإداري</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              {/* <Tab eventKey="enter" title="بيانات العمل الأداري">
                <Enter />
              </Tab> */}
              <Tab eventKey="money" title="بيانات العمل الأداري">
                <Money
                userData={userData}
                  key={key}
                  setKey={setKey}
                  Datee={Datee}
                  setDatee={setDatee}
                  ManageWorkID={ManageWorkID}
                  setManageWorkID={setManageWorkID}
                  Requirework={Requirework}
                  setRequirework={setRequirework}
                  GehaWork={GehaWork}
                  setGehaWork={setGehaWork}
                  MenueWork={MenueWork}
                  setMenueWork={setMenueWork}
                  Result={Result}
                  setResult={setResult}
                  Notes={Notes}
                  setNotes={setNotes}
                  SelectedFile={SelectedFile}
                  setSelectedFile={setSelectedFile}
                  Description={Description}
                  setDescription={setDescription}
                  Loading={Loading}
                  setLoading={setLoading}
                  IsPress={IsPress}
                  setIsPress={setIsPress}
                  IsEdit={IsEdit}
                  setIsEdit={setIsEdit}
                  Eye={Eye}
                  setEye={setEye}
                />
              </Tab>
              <Tab eventKey="display" title="عرض">
                <Display
                  key={key}
                  setKey={setKey}
                  Datee={Datee}
                  setDatee={setDatee}
                  ManageWorkID={ManageWorkID}
                  setManageWorkID={setManageWorkID}
                  Requirework={Requirework}
                  setRequirework={setRequirework}
                  GehaWork={GehaWork}
                  setGehaWork={setGehaWork}
                  MenueWork={MenueWork}
                  setMenueWork={setMenueWork}
                  Result={Result}
                  setResult={setResult}
                  Notes={Notes}
                  setNotes={setNotes}
                  SelectedFile={SelectedFile}
                  setSelectedFile={setSelectedFile}
                  Description={Description}
                  setDescription={setDescription}
                  Loading={Loading}
                  setLoading={setLoading}
                  IsPress={IsPress}
                  setIsPress={setIsPress}
                  IsEdit={IsEdit}
                  setIsEdit={setIsEdit}
                  Eye={Eye}
                  setEye={setEye}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Manageworks;
